import { Injectable, NgModule } from '@angular/core';
import {
  StackableNotificationCardComponent
} from 'ng2-app/notifications/stackable-notifications/stackable-notification-card.component';
import {
  StackableNotificationsManagerComponent
} from 'ng2-app/notifications/stackable-notifications/stackable-notifications-manager.component';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LetDirectiveModule } from 'ng2-app/modules/directives/let/let.directive.module';

@NgModule({
  declarations: [
    StackableNotificationCardComponent,
    StackableNotificationsManagerComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    LetDirectiveModule,
  ],
  exports: [
    StackableNotificationCardComponent,
    StackableNotificationsManagerComponent,
  ],
})
@Injectable({providedIn: 'root'})
export class StackableNotificationsModule {}
